import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: 'Accueil',
  href: '#accueil'
}, {
  label: 'Programmes',
  href: '#programmes'
}, {
  label: 'À propos',
  href: '#apropos'
}, {
  label: 'Cours privés',
  href: '#cours-prives'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setIsMobileMenuOpen(false);
    }
  };
  return <>
      <motion.header initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.5
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-neutral-900 shadow-lg py-2' : 'bg-neutral-900 py-2.5'}`} data-id="element-67">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
          <div className="flex items-center justify-between" data-id="element-69">
            {/* Logo */}
            <a href="#accueil" onClick={e => {
            e.preventDefault();
            scrollToSection('#accueil');
          }} className="flex items-center" data-id="element-70">
              <img src="https://cdn.magicpatterns.com/uploads/vQu9ZWVKGsSy7MjW77SDKE/logo.png" alt="HLD Taekwondo" className={`transition-all duration-300 ${isScrolled ? 'h-14 sm:h-16' : 'h-16 sm:h-20'}`} data-id="element-71" />
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8" data-id="element-72">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => {
              e.preventDefault();
              scrollToSection(link.href);
            }} className="font-medium text-white hover:text-red-400 transition-colors duration-200" data-id="element-73">
                  {link.label}
                </a>)}
            </nav>

            {/* Desktop CTAs */}
            <div className="hidden lg:flex items-center space-x-4" data-id="element-74">
              <a href="tel:450-638-6584" className="px-6 py-2.5 border-2 border-white text-white rounded-full font-semibold hover:bg-white hover:text-neutral-900 transition-all duration-300" data-id="element-75">
                Appeler
              </a>
              <button onClick={() => scrollToSection('#contact')} className="px-6 py-2.5 bg-red-600 text-white rounded-full font-semibold hover:bg-red-700 transition-all duration-300 shadow-lg shadow-red-600/20" data-id="element-76">
                Cours d'essai gratuit
              </button>
            </div>

            {/* Mobile CTAs + Menu */}
            <div className="flex lg:hidden items-center space-x-3" data-id="element-77">
              <button onClick={() => scrollToSection('#contact')} className="px-4 py-2 bg-red-600 text-white rounded-full font-semibold text-sm hover:bg-red-700 transition-colors" data-id="element-78">
                Essai gratuit
              </button>
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 rounded-lg text-white hover:bg-white/10 transition-colors" aria-label="Menu" data-id="element-79">
                {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-80" /> : <Menu className="w-6 h-6" data-id="element-81" />}
              </button>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-82">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-40 lg:hidden" data-id="element-83">
            <div className="absolute inset-0 bg-neutral-900/95 backdrop-blur-lg" data-id="element-84" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="absolute right-0 top-0 bottom-0 w-full max-w-sm bg-white shadow-2xl" data-id="element-85">
              <div className="flex flex-col h-full p-8 pt-24" data-id="element-86">
                {/* Navigation Links */}
                <nav className="flex flex-col space-y-6 mb-12" data-id="element-87">
                  {navLinks.map((link, index) => <motion.a key={link.href} initial={{
                opacity: 0,
                x: 20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: index * 0.1
              }} href={link.href} onClick={e => {
                e.preventDefault();
                scrollToSection(link.href);
              }} className="text-2xl font-bold text-neutral-900 hover:text-red-600 transition-colors" data-id="element-88">
                      {link.label}
                    </motion.a>)}
                </nav>

                {/* Contact Info */}
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.5
            }} className="mt-auto space-y-4 pt-8 border-t border-neutral-200" data-id="element-89">
                  <a href="tel:450-638-6584" className="flex items-center space-x-3 text-neutral-700 hover:text-red-600 transition-colors" data-id="element-90">
                    <Phone className="w-5 h-5" data-id="element-91" />
                    <span className="font-medium" data-id="element-92">450-638-6584</span>
                  </a>
                  <p className="text-sm text-neutral-600" data-id="element-93">
                    5144 Route 132
                    <br data-id="element-94" />
                    Sainte-Catherine, QC, J5C 1L8
                  </p>
                </motion.div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}